// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2pa1q","requiredAsterisk":"Info_requiredAsterisk__37sqR"};